import { enableProdMode, provideZonelessChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { configuration } from '../../mijn-omgeving/mijn-klant-conversational/wrapper/wrapper.bootstrap';

import { RetailKlantConversationalModule } from './retail-klant-conversational.module';

if (configuration !== 'development') {
    enableProdMode();
}

document.addEventListener('DOMContentLoaded', () => {
    platformBrowser()
        .bootstrapModule(RetailKlantConversationalModule, { applicationProviders: [provideZonelessChangeDetection()] })
        .catch((err) => console.error(err)); // NOSONAR
});
